export default "__VITE_ASSET__523SzzqO__"